import {
  Tooltip,
} from "@material-ui/core";
import React from "react";
import "./PropertyDetailView.less";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import CompareIcon from "@material-ui/icons/Compare";
import { checkNegative } from "../../../../utils/generic";

class PropertyDetailView extends React.Component {
  constructor() {
    super();

    this.state = {
      defaultDataList: [],
      dataList: [],
      filterLevel: [],
    };
  }

  componentDidMount() {
    this._groupBy(this.props.PropertyDetail[0]);
  }

  componentWillReceiveProps(newProps) {
    if (
      this.props.PropertyDetail !== newProps.PropertyDetail ||
      this.props.selectedDcName !== newProps.selectedDcName ||
      this.props.startDate !== newProps.startDate
    ) {
      this.setState(
        {
          defaultDataList: [],
          dataList: [],
          filterLevel: [],
        },
        () => {
          this._groupBy(newProps.PropertyDetail[0]);
        }
      );
    }
  }

  /** Group by property */
  _groupBy(myArray) {
    if (myArray == undefined) {
      return false;
    }
    const groups = {};
    for (let i = 0; i < myArray.length; i++) {
      const groupName = myArray[i].attributeName;
      if (!groups[groupName]) {
        groups[groupName] = [];
      }
      const hasChild =
        myArray.find(
          (x) =>
            x.parentAccountCode == myArray[i].accountCode && x.accountCode != ""
        ) != undefined
          ? true
          : false;
      myArray[i].hasChild = hasChild;
      myArray[i].isOpen = false;
      groups[groupName].push(myArray[i]);
    }
    myArray = [];
    for (const groupName in groups) {
      myArray.push(groups[groupName]);
    }
    //console.log(myArray);
    this.processForChildParent(myArray);
    this.setState({ defaultDataList: myArray });
  }

  /** Process for child parent */
  processForChildParent = (DataArray) => {
    const parentArray = [];
    DataArray.map((item) => {
      if (item[0].parentAccountCode == "") {
        parentArray.push(item);
      }
    });
    //console.log(parentArray);
    this.setState({ dataList: parentArray });
  };

  /** Updated table rows for child */
  UpdateTableRowsForChild = (parentID) => {
    const defaultDataList = this.state.defaultDataList;
    const {filterLevel} = this.state;
    if (filterLevel.find((x) => x == parentID) == undefined) {
      filterLevel.push(parentID);
    }
    const toShow = [];

    defaultDataList.map((item) => {
      if (item[0].parentAccountCode == "") {
        toShow.push(item);
        if (
          item[0].accountCode == parentID ||
          filterLevel.find((x) => x == item[0].accountCode)
        ) {
          item[0].isOpen == true;
          const filterData = defaultDataList.filter(
            (x) => x[0].parentAccountCode == item[0].accountCode
          );
          filterData.forEach((x) => {
            toShow.push(x);
            if (
              x[0].accountCode == parentID ||
              filterLevel.find((y) => y == x[0].accountCode)
            ) {
              x[0].isOpen == true;
              const childFilterData = defaultDataList.filter(
                (z) => z[0].parentAccountCode == x[0].accountCode
              );

              childFilterData.forEach((child) => toShow.push(child));
            }
          });
        }
      }
    });
    //console.log(toShow);
    this.setState({ dataList: toShow, filterLevel: filterLevel });
  };

  /** Remove table rows for child */
  RemoveTableRowsForChild = (parentID) => {
    let {dataList} = this.state;
    const {filterLevel} = this.state;
    filterLevel.pop(parentID);
    dataList.map((item) => {
      if (item[0].parentAccountCode == parentID) {
        dataList = dataList.filter((item1) => item1 !== item);
      }
    });
    this.setState({ dataList: dataList, filterLevel: filterLevel });
  };

  /** ICON */
  getIcon(id) {
    const dataList = this.state.dataList;
    let upIcon = false;
    dataList.map((item) => {
      if (item[0].parentAccountCode == id) {
        upIcon = true;
      }
    });
    return upIcon;
  }

  render() {
    const { dataList } = this.state;
    return (
      <table className={"financial-table property-details-view"}>
        <thead>
          <tr
            className={"blue-custom-title"}
            style={{ borderTop: "3px solid #FFFFFF" }}
          >
            <th colSpan={3}> </th>
            <th colSpan={4} className={"border-left"}>
              {"Month To Date\r"}
            </th>
            <th colSpan={4} className={"border-left"}>
              {"Year To Date\r"}
            </th>
          </tr>
          <tr
            className={"blue-custom-title"}
            style={{ borderTop: "3px solid #FFFFFF" }}
          >
            <th colSpan={3}> </th>

            <th className={"border-left"}>{"Budgeted ($)"}</th>
            <th>{"Actual ($)"}</th>
            <th>{"Variance ($)"}</th>
            <th>{"Variance (%)"}</th>

            <th className={"border-left"}>{"Budgeted ($)"}</th>
            <th>{"Actual ($)"}</th>
            <th>{"Variance ($)"}</th>
            <th>{"Variance (%)"}</th>
          </tr>
        </thead>
        <tbody>
          {dataList.length > 0 ? (
            (this.state.dataList || []).map((item, index) => (
              <tr
                key={"FinanceDetailView" + index}
                className={
                  item[0].hasChild == true && item[0].parentAccountCode == ""
                    ? "left-align text-bold"
                    : (item[0].displayAccountCode || "").length > 0
                      ? "left-align child-of-child-row-padding"
                      : "left-align child-row-padding"
                }
              >
                <td>
                  {item[0].parentAccountCode == "" ? (
                    <Tooltip title={"View Graphical Comparison"}>
                      <CompareIcon
                        style={{ width: "16px", cursor: "pointer" }}
                        onClick={() =>
                          this.props.PropertyCompareViewSection
                            ? this.props.switchToComparisonView(
                              item[0].attributeName,
                              item[0].propertyKey,
                              item[0].attributeName
                            )
                            : null}
                      />
                    </Tooltip>
                  ) : null}
                </td>
                <td
                  className={
                    item[0].hasChild == true && item[0].parentAccountCode == ""
                      ? "left-align tex-bold"
                      : (item[0].displayAccountCode || "").length > 0
                        ? "left-align child-of-child-row-padding"
                        : "left-align child-row-padding"
                  }
                  onClick={() => {
                    if (item[0].hasChild && item[0].accountCode != "") {
                      this.RemoveTableRowsForChild(item[0].accountCode);
                    }
                  }}
                >
                  {item[0].attributeName}{" "}
                </td>
                <td className={"border-right "}>
                  {" "}
                  {item[0].hasChild == true && item[0].accountCode != "" ? (
                    this.getIcon(item[0].accountCode) == true ? (
                      <Tooltip title={"Collapse"}>
                        <ArrowDropUpIcon
                          onClick={() =>
                            this.RemoveTableRowsForChild(item[0].accountCode)}
                          style={{ cursor: "pointer" }}
                        />
                      </Tooltip>
                    ) : (
                      <Tooltip title={"Expand "}>
                        <ArrowDropDownIcon
                          onClick={() =>
                            this.UpdateTableRowsForChild(item[0].accountCode)}
                          style={{ cursor: "pointer" }}
                        />
                      </Tooltip>
                    )
                  ) : null}
                </td>
                <td className={" right-align"}>
                  {checkNegative(
                    parseFloat(
                      (item.find((x) => x.attributeType == "MTDBudget") || {})
                        .attributeValue
                    ),
                    false
                  ).toLocaleString()}
                </td>
                <td className={"border-right right-align"}>
                  {checkNegative(
                    parseFloat(
                      (item.find((x) => x.attributeType == "MTDActual") || {})
                        .attributeValue
                    ),
                    false
                  ).toLocaleString()}
                </td>

                <td className={"right-align"}>
                  {checkNegative(
                    parseFloat(
                      (
                        item.find((x) => x.attributeType == "MTDVarianceAmt") ||
                        {}
                      ).attributeValue
                    ),
                    false
                  ).toLocaleString()}
                </td>
                <td className={"border-right right-align"}>
                  {checkNegative(
                    parseFloat(
                      (
                        item.find(
                          (x) => x.attributeType == "MTDVariancePerct"
                        ) || {}
                      ).attributeValue
                    ),
                    false
                  )}
                </td>
                <td className={" right-align"}>
                  {checkNegative(
                    parseFloat(
                      (item.find((x) => x.attributeType == "YTDBudget") || {})
                        .attributeValue
                    ),
                    false
                  ).toLocaleString()}
                </td>
                <td className={"border-right right-align"}>
                  {checkNegative(
                    parseFloat(
                      (item.find((x) => x.attributeType == "YTDActual") || {})
                        .attributeValue
                    ),
                    false
                  ).toLocaleString()}
                </td>

                <td className={"right-align"}>
                  {checkNegative(
                    parseFloat(
                      (
                        item.find((x) => x.attributeType == "YTDVarianceAmt") ||
                        {}
                      ).attributeValue
                    ),
                    false
                  ).toLocaleString()}
                </td>
                <td className={"border-right right-align"}>
                  {checkNegative(
                    parseFloat(
                      (
                        item.find(
                          (x) => x.attributeType == "YTDVariancePerct"
                        ) || {}
                      ).attributeValue
                    ),
                    false
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={13} style={{ textAlign: "center" }}>
                {"No Data Available\r"}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
}

export default PropertyDetailView;
